import { pgEnum } from "drizzle-orm/pg-core";

export const assignmentRole = pgEnum("assignment_role", ["R1", "R2", "R3", "R4", "Supporting"]);

export const podComposition = pgEnum("pod_composition", ["Solo", "Pair", "Trio", "Quad"]);

export const solutionStatus = pgEnum("solution_status", ["Active", "Pending", "Closed"]);

// ── Staffing Requests (docs/specs/staffing-requests.md) ──────────────────────
//
// Inbound staffing-request inbox. Sources arrive in HOURS; the system suggests an
// Intensity and the RM confirms. Hours are never converted to capacity points.

export const staffingRequestStatus = pgEnum("staffing_request_status", [
  "New",
  "Mapping",
  "Mapped",
  "Committed",
  "Rejected",
  "Superseded",
  "Error",
]);

// The technical channel the request arrived through. v1 ships CSV + Excel file
// upload; external_hook is the documented fast-follow (kept in the enum so the
// adapter contract and queue filters are source-agnostic from day one).
export const staffingRequestSourceChannel = pgEnum("staffing_request_source_channel", [
  "csv_upload",
  "excel_upload",
  "external_hook",
]);

// The business kind of the source, chosen by the submitter — surfaced in the queue.
// "Template" is set by the SERVER (never the submitter) when an upload is recognized
// as the structured Staffing Request template (docs/specs/manage-staffing-request-template.md).
export const staffingRequestSourceType = pgEnum("staffing_request_source_type", [
  "SOW",
  "ResourcePlan",
  "ExternalHook",
  "Template",
]);

export const staffingRequestLineStatus = pgEnum("staffing_request_line_status", [
  "Unmapped",
  "Mapped",
  "Committed",
  "Rejected",
]);

// ── Signals (docs/specs/suggested-intensity-from-guidance.md) ────────────────
//
// RM triage layer for Suggested-Intensity-from-Guidance. processSolution raises,
// updates, or auto-resolves a signal; it never writes to Intensity or Pod.

export const signalType = pgEnum("signal_type", [
  "needs_guidance",
  "guidance_change_pod_change",
  "intensity_drift",
  // A Resource has NOS guidance and/or logged actual hours on the Solution's
  // Demands but holds no active assignment on its Pod — suggest adding them.
  // Unlike the three types above (one open per Solution), this is deduped per
  // (Solution, Resource): a Solution may have several off-Pod contributors.
  "resource_off_pod",
]);

export const signalStatus = pgEnum("signal_status", [
  "open",
  "confirmed",
  "dismissed",
  "resolved_by_system",
]);
